<template>
    <!-- one swipeable row on narrow screens; w-max + mx-auto centres it while it fits -->
    <!-- -mx-5 px-5 cancels .container's 1.25rem padding so the row scrolls edge to edge -->
    <nav class="relative mt-6 -mx-5 px-5 overflow-x-auto" style="scrollbar-width: none" :aria-label="$t('editor.product.switch_label')">
        <div class="flex w-max mx-auto rounded-full bg-black bg-opacity-5 p-1">
            <NuxtLink
                v-for="product in products"
                :key="product.route"
                :to="localePath(product.route)"
                class="shrink-0 whitespace-nowrap px-4 py-2 rounded-full text-sm font-Inter-Semibold transition"
                :class="getRouteBaseName() === product.route ?'bg-black text-white' : 'opacity-70 hover:opacity-100'"
            >
                {{ product.labelKey ? $t(product.labelKey) : product.name }}
            </NuxtLink>
        </div>
    </nav>
</template>

<script>
import { MAP_PRODUCTS } from '@/components/Editor/Shared/productOptions';

// Switch between the versions of a map product: the printed poster and the layered wooden one.
export default {
    name: 'MapProductSwitch',
    props: {
        products: { type: Array, default: () => MAP_PRODUCTS },
    },
    mounted() {
        // the current product may sit past the edge of the scrolled row
        const active = this.$el.querySelector('[aria-current="page"]');
        if (active) this.$el.scrollLeft = active.offsetLeft - (this.$el.clientWidth - active.offsetWidth) / 2;
    },
};
</script>
